{
  "info": "معلومات",
  "negative": "خطأ",
  "notice": "تحذير",
  "positive": "تم بنجاح"
}
